import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import Chatbot from '../components/chatbot/Chatbot';
import LandingNav from '../components/landing/LandingNav';
import LandingHero from '../components/landing/LandingHero';
import LandingMarquee from '../components/landing/LandingMarquee';
import LandingServices from '../components/landing/LandingServices';
import LandingProcess from '../components/landing/LandingProcess';
import LandingFaq from '../components/landing/LandingFaq';
import LandingTestimonials from '../components/landing/LandingTestimonials';
import LandingContact from '../components/landing/LandingContact';
import LandingFooter from '../components/landing/LandingFooter';
import LandingAbout from '../components/landing/LandingAbout';

const LandingPage = () => {
  const [form, setForm] = useState({ full_name:'', email:'', phone:'', service:'', message:'' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }, [location.hash]);

  const handleSubmit = async () => {
    if (!form.full_name || !form.email || !form.phone || !form.service || !form.message) {
      return toast.error('Name, email, phone number, service and message are required.');
    }
    setSubmitting(true);
    try {
      await api.post('/api/contact', form);
      setSubmitted(true);
      setForm({ full_name:'', email:'', phone:'', service:'', message:'' });
      toast.success('Message sent! We\'ll reply within 24 hours.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="landing-page" style={{ background:'var(--black)', color:'var(--white)', fontFamily:'DM Sans,sans-serif', overflowX:'hidden' }}>
      <LandingNav mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
      <LandingHero />
      <LandingMarquee />
      <LandingServices />
      <LandingAbout />
      <LandingProcess />
      <LandingFaq />
      <LandingTestimonials />
      <LandingContact
        form={form}
        setForm={setForm}
        submitting={submitting}
        submitted={submitted}
        setSubmitted={setSubmitted}
        handleSubmit={handleSubmit}
      />
      <LandingFooter />
      <Chatbot />

      <style>{`
        @keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
        @media(max-width:1024px){
          .landing-page .desktop-nav{display:none!important;}
          .landing-page .mob-ham{display:flex!important;}
          .landing-page section{padding:80px 28px!important;}
          
          .landing-page .landing-footer{padding:52px 24px 28px!important;width:100%!important;box-sizing:border-box!important;}
          .landing-page div[style*="grid-template-columns: 1fr 1.3fr"]{grid-template-columns:1fr!important;}
          .landing-page div[style*="grid-template-columns: repeat(4"]{grid-template-columns:repeat(2,1fr)!important;}
          .landing-page div[style*="grid-template-columns: repeat(3"]{grid-template-columns:1fr!important;}
        }
        @media(max-width:640px){
          
          .landing-page .landing-footer{padding:44px 16px 24px!important;}
          .landing-page div[style*="grid-template-columns: repeat(2"]{grid-template-columns:1fr!important;}
          .landing-page div[style*="padding: 120px 60px"]{padding:100px 18px 52px!important;}
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
